module.exports = __webpack_public_path__ + "static/media/Apple iPhone 7 Plus Rose Gold.497e42ef.png";